import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import contentApi from '@/services/content-api';

export const contentKeys = {
  page: (page: string) => ['content', page] as const,
};

export function useAboutContent() {
  return useQuery({
    queryKey: contentKeys.page('about'),
    queryFn: () => contentApi.getPage('about'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

export function useUpdateContent(page: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, string>) => contentApi.bulkUpdate(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: contentKeys.page(page) });
      toast.success('Content saved successfully.');
    },
    onError: () => {
      toast.error('Failed to save content. Please try again.');
    },
  });
}
